import { render } from "./AvatarSpecial.vue?vue&type=template&id=e7d0157c&scoped=true"
import script from "./AvatarSpecial.vue?vue&type=script&lang=js"
export * from "./AvatarSpecial.vue?vue&type=script&lang=js"

import "./AvatarSpecial.vue?vue&type=style&index=0&id=e7d0157c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_48ac5cde7c36a6fbb3736f36e5a55bfb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7d0157c"]])

export default __exports__